export default "__VITE_ASSET__D2kTdi1n__"